import { capitalize } from './text-helper';
// COVID-19 😈
const convertCoronavirusLink = text => text.replace(/https:\/\/busfor.com\/[A-z/]+\/covid-19-updates/, `<a href="$&" target="_blank">${I18n.t('components.CriticalInfo.find_out_here')}</a>`);
export const getCriticalText = criticalInfo => criticalInfo.map(text => convertCoronavirusLink(capitalize(text))).join(', ');